import { createSelector } from '@ngrx/store';

import { locationsFiltersState } from '../root';

export const getLocationFilters = createSelector(locationsFiltersState, (locationsFilters) => locationsFilters);
